import type { SearchFilterState } from '../../types'
import { formatIncExcSegment } from './helpers'
import {
  formatSegments,
  getEngineMarkets,
  getMediaTypeStrings,
  getStatus,
} from './segments'

/** Assembles the full pipe-delimited criteria string from a {@link SearchFilterState}. */
export const encodeCriteriaString = (
  searchState: SearchFilterState,
): string => {
  const criteria = [
    getMediaTypeStrings(searchState),
    getEngineMarkets(searchState),
    getStatus(searchState),
    ...formatSegments(searchState),
    formatIncExcSegment(
      'Provider',
      searchState.mediaDetails.providerMode === 'include'
        ? searchState.mediaDetails.provider
        : [],
      searchState.mediaDetails.providerMode === 'exclude'
        ? searchState.mediaDetails.provider
        : [],
    ),
  ]
    .filter((i) => !(i === '' || i === null))
    .join('|')

  return criteria
}

/** Writes the current criteria string into the browser URL as the `Criteria` query parameter. */
export const addCriteriaStringToSearchParams = (
  searchFilterState: SearchFilterState,
) => {
  const criteriaString = encodeCriteriaString(searchFilterState)

  // Encode the criteria value but decode back characters that are safe and
  // human-readable in a URL query string so the address bar isn't a wall of %XX.
  const encodedCriteria = encodeURIComponent(criteriaString)
    .replace(/%7C/g, '|')
    .replace(/%3A/g, ':')
    .replace(/%2C/g, ',')
    .replace(/%5E/g, '^')
    .replace(/%2F/g, '/')
    .replace(/%20/g, '+')

  const otherParams = new URLSearchParams(window.location.search)
  otherParams.delete('Criteria')
  const rest = otherParams.toString()
  const qs = rest
    ? `${rest}&Criteria=${encodedCriteria}`
    : `Criteria=${encodedCriteria}`

  window.history.replaceState(
    undefined,
    '',
    `${window.location.origin}${window.location.pathname}?${qs}`,
  )
}
